import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DayOfWeek } from '@vendasta/meetings';

@Pipe({
  name: 'dayofweek',
  standalone: false,
})
export class DayOfWeekPipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}
  dayNames = new Map<DayOfWeek, string>([
    [DayOfWeek.MONDAY, 'MEETING_SCHEDULER.COMMON.DAYS.MONDAY'],
    [DayOfWeek.TUESDAY, 'MEETING_SCHEDULER.COMMON.DAYS.TUESDAY'],
    [DayOfWeek.WEDNESDAY, 'MEETING_SCHEDULER.COMMON.DAYS.WEDNESDAY'],
    [DayOfWeek.THURSDAY, 'MEETING_SCHEDULER.COMMON.DAYS.THURSDAY'],
    [DayOfWeek.FRIDAY, 'MEETING_SCHEDULER.COMMON.DAYS.FRIDAY'],
    [DayOfWeek.SATURDAY, 'MEETING_SCHEDULER.COMMON.DAYS.SATURDAY'],
    [DayOfWeek.SUNDAY, 'MEETING_SCHEDULER.COMMON.DAYS.SUNDAY'],
  ]);

  transform(day: DayOfWeek): string {
    const translationKey = this.dayNames.get(day);
    return translationKey ? this.translate.instant(translationKey) : '';
  }
}
